/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
/* eslint-disable max-len */
import { ActivatedRoute } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import { ModalController, NavController, ToastController } from '@ionic/angular';
import { NotificationsService } from '../services/notifications.service';
import { AngularFireDatabase } from '@angular/fire/database';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';

import { AuthService } from './auth.service';
import { SelectGroupComponent } from '../components/select-group/select-group.component';
import { GroupService } from './group.service';

@Injectable({
    providedIn: 'root'
})

export class SquareService {

    endReached = false;
    squares = [];
    square;
    storage = firebase.storage();
    currentUser = this.authService.currentUser;
    unsub1;
    constructor(
        public firestore: AngularFirestore,
        public database: AngularFireDatabase,
        public authService: AuthService,
        public route: ActivatedRoute,
        public toastController: ToastController,
        public navController: NavController,
        public modalController: ModalController,
        public notificationsService: NotificationsService,
        public groupService: GroupService
    ) {
        this.unsub1 = this.authService.currentAccount.subscribe(async (user) => {
            if (user) {
                this.currentUser = user;
            }
        });
    }

    async getUserSquares(id) {
        return new Promise(async (resolve, reject) => {
            const data = [];
            const square = this.firestore.collection('squares', ref => ref.where('admins', 'array-contains', id));
            const documentSnapshots = await square.get().toPromise();
            documentSnapshots.forEach(async docRef => {
                const x = docRef.data();
                (x as any).id = docRef.id;
                data.push(x);
            });
            return resolve(data);
        });
    }

    // async getGroups() {
    //     return new Promise(async (resolve, reject) => {
    //         let data;
    //         const square = this.firestore.collection('squares', ref => ref.orderBy('recentlyActive'));
    //         const documentSnapshots = await square.get().toPromise();
    //         documentSnapshots.forEach(async docRef => {
    //             data = docRef.data();
    //             data.id = docRef.id;
    //         });
    //         resolve(data);
    //     });
    // }

    async getSquareOnce(id) {
        return new Promise(async (resolve, reject) => {
            const docRef = this.firestore.collection('squares').doc(id);
            const docSnap = await docRef.get().toPromise();
            if (docSnap.exists) {
                const square = { id: docSnap.id, ...((docSnap.data() as any) || {}) };
                return resolve(square);
            } else {
                return resolve(undefined);
            }
        });
    }

    async getSquare(id) {
        // eslint-disable-next-line @typescript-eslint/no-shadow
        if (this.unsub1) {
            this.clearSquare();
        }
        this.unsub1 = this.firestore.collection('squares').doc(id).snapshotChanges().subscribe(async (result) => {
            const data = result.payload.data() as any;
            this.square = { id: result.payload.id, isEditable: data?.admins?.includes(this.currentUser?.id), ...data };
            console.log(this.square);
            window.dispatchEvent(new Event('square-update'));
        });
    }

    clearSquare() {
        if (this.unsub1 && this.unsub1.unsubscribe) {
            this.unsub1.unsubscribe();
        }
        this.unsub1 = undefined;
        this.square = undefined;
    }

    async createOrUpdateSquare(id, data) {
        Object.keys(data).forEach(key => {
            if (data[key] === undefined || data[key] === null) {
                delete data[key];
            }
        });
        data.nameLower = data.name.toLowerCase();
        if (id) {
            return await this.firestore.collection('squares').doc(id).update(data);
        } else {
            return await this.firestore.collection('squares').add({
                ...data,
            });
        }
    }

    async getSquares(more) {
        const limitCount = 25;
        if (!more) {
            this.endReached = false;
            this.squares = [];
            const first = this.firestore.collection('squares', ref => ref.orderBy('recentlyActive').limit(limitCount));
            const documentSnapshots = await first.get().toPromise();
            documentSnapshots.forEach(async (docRef) => {
                const square: any = { id: docRef.id, ...((docRef.data() as any) || {}) };
                if (!Array.isArray(square?.joined)) { square.joined = []; }
                await square.joined.forEach(async (id) => {
                    if (!Array.isArray(square?.joinedGroupData)) { square.joinedGroupData = []; }
                    square.joinedGroupData.push(await this.groupService.getGroupOnce(id));
                });
                this.squares.push(square);
                console.log(this.squares);
            });
        } else {
            const lastVisible = this.squares[this.squares.length - 1];
            if (lastVisible && !this.endReached) {
                const next = this.firestore.collection('squares', ref => ref.orderBy('recentlyActive').startAfter(lastVisible).limit(25));
                const documentSnapshots = await next.get().toPromise();
                if (documentSnapshots.size < limitCount) { this.endReached = true; }
                documentSnapshots.forEach(async (docRef) => {
                    const square: any = { id: docRef.id, ...((docRef.data() as any) || {}) };
                    if (!Array.isArray(square?.joined)) { square.joined = []; }
                    await square.joined.forEach(async (id) => {
                        if (!Array.isArray(square?.joinedGroupData)) { square.joinedGroupData = []; }
                        square.joinedGroupData.push(await this.groupService.getGroupOnce(id));
                    });
                    this.squares.push(square);
                });
            }
        }
    }


    async getSquaresByQueryConstraints(more, queryConstraints) {
        const limitCount = 25;
        if (!more) {
            this.endReached = false;
            this.squares = [];
            const first = this.firestore.collection('squares', ref => ref.limit(limitCount));
            const documentSnapshots = await first.get().toPromise();
            documentSnapshots.forEach(async (docRef) => {
                const square: any = { id: docRef.id, ...((docRef.data() as any) || {}) };
                if (!Array.isArray(square?.joined)) { square.joined = []; }
                await square.joined.forEach(async (id) => {
                    if (!Array.isArray(square?.joinedUserData)) { square.joinedUserData = []; }
                    square.joinedUserData.push(await this.authService.getUserById(id));
                });
                this.squares.push(square);
                console.log(this.squares);
            });
        } else {
            const lastVisible = this.squares[this.squares.length - 1];
            if (lastVisible && !this.endReached) {
                const next = this.firestore.collection('squares', ref => ref.orderBy('recentlyActive').startAfter(lastVisible).limit(25));
                const documentSnapshots = await next.get().toPromise();
                if (documentSnapshots.size < limitCount) { this.endReached = true; }
                documentSnapshots.forEach(async (docRef) => {
                    const square: any = { id: docRef.id, ...((docRef.data() as any) || {}) };
                    if (!Array.isArray(square?.joined)) { square.joined = []; }
                    await square.joined.forEach(async (id) => {
                        if (!Array.isArray(square?.joinedUserData)) { square.joinedUserData = []; }
                        square.joinedUserData.push(await this.authService.getUserById(id));
                    });
                    this.squares.push(square);
                });
            }
        }
    }
    async like() {
        if (!this.square || !this.currentUser) {return;}
        if (!Array.isArray(this.square?.likes)) { this.square.likes = []; }
        const docRef = this.firestore.collection('squares').doc(this.square.id);
        if (this.square?.likes?.includes(this.currentUser.id)) {
            // this.square.likes.splice(this.square.likes.indexOf(this.currentUser.id), 1);
            // docRef.update({
            //     likes: firebase.firestore.FieldValue.arrayRemove(this.currentUser.id)
            // });
        } else {
            this.square.likes.push(this.currentUser.id);
            docRef.update({
                likes: firebase.firestore.FieldValue.arrayUnion(this.currentUser.id)
            });
        }
    }

    async join() {
        if (!this.square) {return;}
        const modal = await this.modalController.create({
            component: SelectGroupComponent,
            cssClass: 'messages-modal',
            breakpoints: [0.25, 0.5, 0.75, 1],
            initialBreakpoint: 0.5,
            componentProps: {
                joined: this.square.joined,
            }
        });
        modal.onDidDismiss().then((res) => {
            console.log(res);
            const groupId = res.data;
            if (groupId) {
                if (this.square?.type === 'public') {
                    if (!Array.isArray(this.square?.joined)) { this.square.joined = []; }
                    const docRef = this.firestore.collection('squares').doc(this.square.id);
                    if (this.square?.joined?.includes(groupId)) {
                        this.square.joined.splice(this.square.joined.indexOf(groupId), 1);
                        docRef.update({
                            joined: firebase.firestore.FieldValue.arrayRemove(groupId),
                            joinRequests: firebase.firestore.FieldValue.arrayRemove(groupId),
                        });
                    } else {
                        this.square.joined.push(groupId);
                        docRef.update({
                            joined: firebase.firestore.FieldValue.arrayUnion(groupId),
                            joinRequests: firebase.firestore.FieldValue.arrayRemove(groupId)
                        });
                    }
                }
                if (this.square?.type === 'private') {
                    this.joinRequests(groupId);
                }
            }
        });
        return await modal.present();
    }

    async joinRequests(groupId) {
        if (!this.square) {return;}
        if (!Array.isArray(this.square?.joinRequests)) { this.square.joinRequests = []; }
        const docRef = this.firestore.collection('squares').doc(this.square.id);
        if (this.square?.joined?.includes(groupId) || this.square?.joinRequests?.includes(groupId)) {
            this.square.joined.splice(this.square.joined.indexOf(groupId), 1);
            this.square.joinRequests.splice(this.square.joinRequests.indexOf(groupId), 1);
            docRef.update({
                joined: firebase.firestore.FieldValue.arrayRemove(groupId),
                joinRequests: firebase.firestore.FieldValue.arrayRemove(groupId),
            });
        } else {
            if (this.square?.joined) {
                this.square.joined.splice(this.square.joined.indexOf(groupId), 1);
            }
            this.square.joinRequests.push(groupId);
            docRef.update({
                joined: firebase.firestore.FieldValue.arrayRemove(groupId),
                joinRequests: firebase.firestore.FieldValue.arrayUnion(groupId),
            });
        }
    }

    async joinAccept(groupId) {
        if (!this.square) {return;}
        if (!Array.isArray(this.square?.joinRequests)) { this.square.joinRequests = []; }
        const docRef = this.firestore.collection('squares').doc(this.square.id);
        if (this.square?.joined?.includes(groupId)) {
            // Already joined
        } else {
            this.square.joined.push(groupId);
            this.square.joinRequests.splice(this.square.joinRequests.indexOf(groupId), 1);
            docRef.update({
                joined: firebase.firestore.FieldValue.arrayUnion(groupId),
                joinRequests: firebase.firestore.FieldValue.arrayRemove(groupId)
            });
        }
    }

    async joinReject(groupId) {
        if (!this.square) {return;}
        if (!Array.isArray(this.square?.joinRequests)) { this.square.joinRequests = []; }
        const docRef = this.firestore.collection('squares').doc(this.square.id);
        this.square.joined.splice(this.square.joined.indexOf(groupId), 1);
        this.square.joinRequests.splice(this.square.joinRequests.indexOf(groupId), 1);
        docRef.update({
            joined: firebase.firestore.FieldValue.arrayRemove(groupId),
            joinRequests: firebase.firestore.FieldValue.arrayRemove(groupId),
        });
    }


    async presentToast(message) {
        const toast = await this.toastController.create({
            message,
            duration: 3000,
            position: 'top',
        });
        toast.present();
    }
}
